import * as React from "react";
import MUIDataTableLib, { MUIDataTableColumn } from "mui-datatables";
// Rolldown (Vite 8) doesn't recognize exports.default on CJS modules without __esModule:true,
// so the default import arrives as the full module namespace object. Access .default explicitly.
const MUIDataTable = ((MUIDataTableLib as any).default ?? MUIDataTableLib) as typeof MUIDataTableLib;

interface IMUIDataTableMobileProps {
  title: string;
  columns: unknown[];
  data: unknown[];
  options: unknown;
  setExpandableRowContent?: (rowData: unknown[], rowMeta?: unknown) => React.ReactNode;
  onRowClick?: (data: unknown, tableMeta?: unknown) => void;
}

const MUIDataTableMobile: React.FunctionComponent<IMUIDataTableMobileProps> = (
  props
) => {
  // Create custom columns with click handler for cells with 'onclick-first-cell' class
  const customColumns = (props.columns as any[]).map((col: any) => {
    if (col.options?.setCellProps) {
      // This is the Member ID column - add custom render to handle clicks
      return {
        ...col,
        options: {
          ...col.options,
          customBodyRender: (value: any, tableMeta: any) => {
            return (
              <div
                className="onclick-first-cell"
                onClick={(e) => {
                  e.stopPropagation(); // Prevent row expansion
                  if (props.onRowClick && tableMeta) {
                    // Pass the row data array and tableMeta with dataIndex
                    // This matches desktop behavior where MemberSearch uses meta.dataIndex
                    // to look up the full searchResult object
                    props.onRowClick(tableMeta.rowData, { dataIndex: tableMeta.rowIndex });
                  }
                }}
                style={{ textDecoration: 'underline', cursor: 'pointer' }}
              >
                {value}
              </div>
            );
          },
        },
      };
    }
    return col;
  });

  return (
    <MUIDataTable
      title={props.title}
      columns={customColumns as MUIDataTableColumn[]}
      data={props.data as object[]}
      options={{
        ...(props.options as object),
        responsive: "standard",
        expandableRows: true,
        expandableRowsOnClick: true,
        isRowExpandable: () => {
          return true;
        },
        renderExpandableRow: (rowData: unknown[], rowMeta: unknown) => {
          return props.setExpandableRowContent?.(rowData, rowMeta);
        },
      }}
    />
  );
};

export default MUIDataTableMobile;
